"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _UserContext = require("@insided/shared/services/UserContext");

var _TopicListItemCardHeader = _interopRequireDefault(require("./TopicListItemCardHeader"));

var _TopicListItemCardFooter = _interopRequireDefault(require("./TopicListItemCardFooter"));

var _TopicListItemCardBody = _interopRequireDefault(require("./TopicListItemCardBody"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StickyFlag = _interopRequireDefault(require("@insided/destination/icons/StickyFlag"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicListItemCard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicListItemCard, _Component);

  var _super = _createSuper(TopicListItemCard);

  function TopicListItemCard() {
    (0, _classCallCheck2.default)(this, TopicListItemCard);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(TopicListItemCard, [{
    key: "render",
    value: function render() {
      var _authors$author$id, _authors$lastContribu;

      var _this$props = this.props,
          topic = _this$props.topic,
          authors = _this$props.authors,
          hideCategoryMetadata = _this$props.hideCategoryMetadata,
          attachmentCdn = _this$props.attachmentCdn,
          handleFavoriteRemoval = _this$props.handleFavoriteRemoval,
          isUnreadPostCountEnabled = _this$props.isUnreadPostCountEnabled,
          isNew = _this$props.isNew,
          clickCallback = _this$props.clickCallback,
          showUnsubscribeBtn = _this$props.showUnsubscribeBtn;
      var author = topic.author,
          lastContributor = topic.lastContributor,
          contentType = topic.contentType,
          categoryName = topic.categoryName,
          categoryUrl = topic.categoryUrl,
          sticky = topic.sticky;
      var defaultAuthor = {
        id: '',
        name: 'Anonymous',
        avatar: ''
      };
      var topicAuthor = (_authors$author$id = authors[author === null || author === void 0 ? void 0 : author.id]) !== null && _authors$author$id !== void 0 ? _authors$author$id : defaultAuthor;
      var userTitle = topicAuthor.userTitle;
      var lastTopicContributor = (_authors$lastContribu = authors[lastContributor.id]) !== null && _authors$lastContribu !== void 0 ? _authors$lastContribu : defaultAuthor;
      return (0, _preact.h)(_UserContext.CurrentUserContext.Consumer, null, function (user) {
        return (0, _preact.h)("div", {
          className: (0, _classnames.default)('topic-list-item-card', {
            'topic-list-item-card--sticky': sticky
          })
        }, sticky && (0, _preact.h)(_StickyFlag.default, {
          className: "topic-view_sticky-flag"
        }), (0, _preact.h)("div", {
          className: "topic-list-item-card_info-container"
        }, (0, _preact.h)(_TopicListItemCardHeader.default, {
          categoryName: categoryName,
          categoryUrl: categoryUrl,
          contentType: contentType,
          user: topicAuthor,
          userTitle: userTitle,
          hideCategoryMetadata: hideCategoryMetadata
        }), (0, _preact.h)(_TopicListItemCardBody.default, {
          topic: topic,
          attachmentCdn: attachmentCdn,
          isUnreadPostCountEnabled: isUnreadPostCountEnabled,
          isNew: isNew,
          clickCallback: clickCallback
        }), (0, _preact.h)(_TopicListItemCardFooter.default, {
          lastTopicContributor: lastTopicContributor,
          topic: topic,
          userId: user.id,
          handleFavoriteRemoval: handleFavoriteRemoval,
          showUnsubscribeBtn: showUnsubscribeBtn
        })));
      });
    }
  }]);
  return TopicListItemCard;
}(_preact.Component);

var _default = TopicListItemCard;
exports.default = _default;